import React from "react";
import "./styles.css";

import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPhone,
    faMailBulk,
} from "@fortawesome/free-solid-svg-icons";

export default class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-section">
                    <p>Miroslav Babinčák</p>
                    <a href="mailto: babincak.m@gmail.com"><FontAwesomeIcon icon={faMailBulk}/> babincak.m@gmail.com</a>
                    <a href="tel: +421 907 618 680"> <FontAwesomeIcon icon={faPhone} /> +421 907 618 680</a>
                </div>
                <div className="footer-section">
                    <Iframe
                        className="iframe-minimap"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d164.38125136721607!2d21.919901474238777!3d48.76088618601946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4739330ff890a3d5%3A0x8ff6d00c0f054b2c!2sHostinec%20u%20Milky!5e0!3m2!1ssk!2ssk!4v1627598536843!5m2!1ssk!2ssk"
                        style={{border:"0"}}
                        allowfullscreen=""
                        loading="lazy"
                    ></Iframe>
                </div>
            </div>
        );
    }
}
